$('.map--region__title').on('click', function(e) {
  e.preventDefault();
  $(this).toggleClass('is-expanded');
});

$('.map--region__city').on('click', function(e) {
  e.preventDefault();
  $('.map--modal').removeClass('is-showing');
  $('.map--modals').addClass('is-showing');
  $( $(this).attr('href') ).toggleClass('is-showing');
});

$('.map--modal__close').on('click', function(e) {
  e.preventDefault();
  $('.map--modals').removeClass('is-showing');
  $('.map--modal').removeClass('is-showing');
});



    // $('.leadership--item').removeClass('is-expanded').attr('aria-expanded','false');
    // 8    $(this).parent().addClass('is-expanded');
    // 9:   $(this).attr('aria-expanded','true');